(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.SeventyTax = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  const OZ_TO_G = 28.349523125;
  const MEASUREMENTS = [[4.5,41,8],[5,50,15],[6,64,31],[6,50,18],[7,58,21],[6.5,54,14],[4.5,48,11],[4.5,38,6],[7.5,40,12],[6.25,60,22],[5,56,20],[6.5,50,17],[7.5,52,21],[7,64,27],[7,70,40],[6,50,16]];
  const DENSITY = MEASUREMENTS.reduce((sum,[length,ring,weight]) => sum + weight / (length * ring * ring), 0) / MEASUREMENTS.length;
  const RULES = Object.freeze({ checked: '2026-10-14', kr: { cigar: { excise:61, tobacco:103 }, pipe:{excise:21,tobacco:36},ryo:{excise:21,tobacco:36}, education:0.4399, duty:0.4, vat:0.1 }, jp: { wto:{cigar:0.16,pipe:0.298,ryo:0.298},ryoWithPapers:0.034,personal:{national:14.424,special:0.82},consumption:0.078 } });
  function number(value, label, min=0, max=1e12) {
    if (value === '' || value === null || value === undefined || typeof value === 'boolean') throw new Error(label + '을(를) 입력해 주세요.');
    const n = Number(value);
    if (!Number.isFinite(n) || n < min || n > max) throw new Error(label + '의 입력 범위를 확인해 주세요.');
    return n;
  }
  const floor = (n, step=1) => Math.floor((n + 1e-9) / step) * step;
  const atMost = (n, limit) => n <= limit + 1e-9;
  // US-warehouse shipping scope: fixed WTO rates; ignore legacy preference fields.
  function japanDutyRate(item) { return item.type==='ryo'&&item.ryoPaper==='yes'?RULES.jp.ryoWithPapers:RULES.jp.wto[item.type]; }
  // Customs basic circular 13-4-2/3 and Customs Answer 1111:
  // round bases per declaration line, but round tax totals only after summing lines.
  function japanDeclarationTaxes(lines, exempt=false) {
    const details=lines.map(line=>{
      const dutyRaw=exempt?0:floor(floor(line.value,1000)*line.dutyRate);
      const nationalRaw=floor(line.nationalRaw||0),specialRaw=floor(line.specialRaw||0);
      const consumptionBase=floor(line.value+floor(dutyRaw,100)+floor(nationalRaw,100)+floor(specialRaw,100),1000);
      const consumptionRaw=exempt?0:floor(consumptionBase*(line.consumptionRate===undefined?RULES.jp.consumption:line.consumptionRate));
      const localRaw=exempt?0:floor(floor(consumptionRaw,100)*22/78);
      return {...line,dutyRaw,nationalRaw,specialRaw,consumptionBase,consumptionRaw,localRaw};
    });
    const sum=key=>floor(details.reduce((s,line)=>s+line[key],0),100);
    return {national:sum('nationalRaw'),special:sum('specialRaw'),duty:sum('dutyRaw'),consumption:sum('consumptionRaw'),localConsumption:sum('localRaw'),details};
  }
  function japanTobaccoLines(items,base,price) {
    const groups=new Map();
    items.forEach(i=>{
      const hs=i.type==='cigar'?'240210000':i.type==='ryo'&&i.ryoPaper==='yes'?'240319200':'240319100';
      if(!groups.has(hs))groups.set(hs,{hs,category:i.type==='cigar'?'cigar':'pipe',price:0,tenths:0,dutyRate:japanDutyRate(i)});
      const g=groups.get(hs);
      g.price+=i.price;
      // NTA tobacco circular 19/20: truncate EACH stick/pack to 0.1g first.
      g.tenths+=(i.type==='cigar'?Math.max(10,floor(i.unit*10)):floor(i.unit*10))*i.quantity;
    });
    const lines=[...groups.values()].sort((a,b)=>a.hs.localeCompare(b.hs));
    // The guide assumes one declaration line per HS/rate. Where a fiscal category
    // spans two HS lines, allocate its whole equivalent count by largest remainder.
    // This is an estimate convention, NOT a mandated customs allocation rule;
    // retain the existing mixed-classification warning in all languages.
    for(const category of ['cigar','pipe']) {
      const subset=lines.filter(g=>g.category===category);
      let remaining=floor(subset.reduce((s,g)=>s+g.tenths,0)/10);
      subset.forEach(g=>{g.equivalent=floor(g.tenths/10);remaining-=g.equivalent;});
      [...subset].sort((a,b)=>(b.tenths%10)-(a.tenths%10)||a.hs.localeCompare(b.hs)).forEach(g=>{if(remaining>0){g.equivalent++;remaining--;}});
      // NTA circular 22: whole-yen tax is assessed per fiscal category, not HS.
      for(const [key,rate] of [['nationalRaw',RULES.jp.personal.national],['specialRaw',RULES.jp.personal.special]]) {
        let yen=floor(subset.reduce((s,g)=>s+g.equivalent,0)*rate);
        subset.forEach(g=>{g[key]=floor(g.equivalent*rate);yen-=g[key];});
        [...subset].sort((a,b)=>(b.equivalent*rate%1)-(a.equivalent*rate%1)||a.hs.localeCompare(b.hs)).forEach(g=>{if(yen>0){g[key]++;yen--;}});
      }
    }
    return lines.map(g=>({...g,value:base*g.price/price}));
  }
  function itemWeight(item, scenario='expected') {
    if (!['cigar','pipe','ryo'].includes(item.type)) throw new Error('상품 종류를 확인해 주세요.');
    if(item.type==='ryo' && item.ryoPaper!==undefined && !['unknown','no','yes'].includes(item.ryoPaper))throw new Error('Invalid rolling-paper packaging.');
    const quantity = number(item.quantity,'수량',1,100000);
    if (!Number.isInteger(quantity)) throw new Error('수량은 정수로 입력해 주세요.');
    let unit;
    if (item.type === 'pipe' || item.type === 'ryo') {
      if (!['g','oz'].includes(item.unit)) throw new Error('중량 단위를 확인해 주세요.');
      unit = number(item.weight,'포장당 순중량',0.000001,100000) * (item.unit==='oz' ? OZ_TO_G : 1);
    } else if (item.mode === 'manual') {
      unit = number(item.weight,'개비당 실측 무게',0.000001,100000);
      if (item.weightBasis === 'total') unit /= quantity;
      else if (item.weightBasis !== undefined && item.weightBasis !== 'unit') throw new Error('실측 무게 기준을 확인해 주세요.');
    } else if (item.mode === 'estimate') {
      if (!['in','mm'].includes(item.lengthUnit)) throw new Error('길이 단위를 확인해 주세요.');
      if (!['regular','figurado'].includes(item.shape)) throw new Error('시가 모양을 확인해 주세요.');
      const length = number(item.length,'길이',0.01,1000) / (item.lengthUnit === 'mm' ? 25.4 : 1);
      const ring = number(item.ring,'링게이지',1,200);
      unit = length * ring ** 2 * DENSITY * (item.shape==='figurado' ? 0.85 : 1);
      unit *= scenario === 'low' ? 0.85 : scenario === 'high' ? 1.15 : 1;
    } else throw new Error('무게 입력 방식을 확인해 주세요.');
    return {quantity, unit, total: unit * quantity, estimated: item.type==='cigar' && item.mode==='estimate'};
  }
  function calculate(order, scenario='expected') {
    if (!['KR','JP'].includes(order.country)) throw new Error('배송 국가를 선택해 주세요.');
    if (!Array.isArray(order.items) || !order.items.length) throw new Error('주문 상품을 한 개 이상 추가해 주세요.');
    const rate = number(order.rate,'세관 고시환율',0.000001,1000000);
    const shipping = number(order.shipping,'국제 배송비');
    const foreign = number(order.foreign === undefined ? 0 : order.foreign,'발송국 내 비용');
    const domestic = number(order.shippingMode==='direct' ? 0 : order.domestic === undefined ? 0 : order.domestic,'발송국 내 배송비');
    const insurance = number(order.insurance === undefined ? 0 : order.insurance,'국제 보험료');
    const items = order.items.map(item => ({...item,...itemWeight(item,scenario),price:number(item.price,'상품별 합계 가격')}));
    const price = items.reduce((s,i) => s+i.price,0);
    if (price <= 0) throw new Error('상품 가격 합계는 0보다 커야 합니다.');
    const weight = items.reduce((s,i) => s+i.total,0);
    const cigarCount = items.filter(i=>i.type==='cigar').reduce((s,i)=>s+i.quantity,0);
    const pipeWeight = items.filter(i=>i.type==='pipe').reduce((s,i)=>s+i.total,0);
    const ryoWeight = items.filter(i=>i.type==='ryo').reduce((s,i)=>s+i.total,0);
    const ryoMixed = ryoWeight>0 && (cigarCount>0 || pipeWeight>0);
    const hasCigar = cigarCount>0, hasPipe = pipeWeight>0;
    const cashCost = (price+foreign+domestic+shipping+insurance)*rate;
    const rows = [], notes = [];
    let base, exempt, total, equivalent=0, status, exciseWaived=false, exciseAssessed=0, reliefOptions=[], mixedRelief='none';
    if (order.country === 'KR') {
      base = cashCost;
      const mixed = (hasCigar && hasPipe) || ryoMixed;
      exempt = !mixed && atMost(price+foreign+domestic,150) && (!hasCigar || cigarCount<=50) && (!hasPipe || atMost(pipeWeight,250)) && atMost(ryoWeight,250);
      status = mixed ? 'mixed' : exempt ? 'exempt' : 'taxed';
      let exciseRaw=0,tobaccoRaw=0;
      items.forEach(i=>{exciseRaw+=i.total*RULES.kr[i.type].excise;tobaccoRaw+=i.total*RULES.kr[i.type].tobacco;});
      exciseAssessed=floor(exciseRaw);
      // Retained guide convention per user-reported clearance experience; customs makes the final decision.
      exciseWaived=exciseAssessed<10000;
      const excise=exciseWaived ? 0 : exciseAssessed,tobacco=floor(tobaccoRaw),education=floor(tobacco*RULES.kr.education);
      // Do not infer a confirmed relief category or allocate away common shipping.
      const taxedBase=exempt?0:base;
      const taxableExcise=exempt?0:excise;
      const duty=floor(taxedBase*RULES.kr.duty);
      // VAT Act art. 29(2): local tobacco tax and local education tax are not in the import VAT base.
      const vatBase=taxedBase+duty+taxableExcise;
      const vat=floor(vatBase*RULES.kr.vat);
      rows.push(['개별소비세',excise],['담배소비세',tobacco],['지방교육세 · 담배소비세의 43.99%',education],['관세 · 일반세율 40%',duty],['부가가치세 · 10%',vat]);
      if (mixed) notes.push('혼합 주문은 한 종류의 담배만 관부가세 혜택 대상으로 추정합니다. 적용 대상은 통관 세관 확인이 필요하며, 미확인 상태의 내역에는 혜택을 반영하지 않습니다.');
      if(exciseWaived)notes.push('산출 개별소비세 '+exciseAssessed+'원이 10,000원 이하이므로 이 참고 가이드에서 면제 처리했습니다. 실제 적용 여부는 관세청·통관 세관 판단을 따릅니다. 담배소비세와 지방교육세는 별도입니다.');
      notes.push('부가세 과세표준 = 과세가격 + 관세 + 개별소비세. 발송국 내 비용은 $150 판정에 포함하며 별도 표시된 국제 운송비·보험료는 판정에서 제외합니다.');
    } else {
      base = (price+foreign)*rate*0.6;
      exempt = atMost(base,10000);
      status = exempt ? 'exempt' : 'taxed';
      const lines=japanTobaccoLines(items,base,price);
      equivalent=lines.reduce((s,line)=>s+line.equivalent,0);
      const classificationGroups=exempt?0:lines.length;
      const {national,special,duty,consumption,localConsumption}=japanDeclarationTaxes(lines,exempt);
      rows.push(['국가 담배세',national],['담배특별세',special],['관세 · WTO 세율',duty],['수입 소비세 · 7.8%',consumption],['지방소비세 · 소비세의 22/78',localConsumption]);
      notes.push('개인 자가사용 기준: 해외 소매가격(물품가격·현지 세금·기타 비용) × 60% × 고시환율로 과세가격을 추정합니다. 별도 표시된 발송국 내·국제 배송비 및 국제 보험료는 과세가격에서 제외합니다.');
      notes.push('담배세·특별세는 면세되지 않습니다. 과세가격 10,000엔 이하일 때 관세·소비세만 면제합니다. 시가 1개비가 1g 미만이면 1개비를 1g 상당으로 계산합니다.');
      if(classificationGroups>1)notes.push('복수 품목의 소비세는 합산 기준으로 추정합니다. 실제 신고서의 품목별 과세표준 및 끝수 처리로 결과가 달라질 수 있습니다.');
      notes.push('일본은 시가 개비당 0.1g 절사, 종류별 환산수량의 소수 절사, 관세·소비세 과세표준 1,000엔 및 세액 100엔 절사를 반영합니다. 실제 신고 품목 구분에 따라 차이가 날 수 있습니다.');
    }
    total=rows.reduce((s,r)=>s+r[1],0);
    const result={country:order.country,currency:order.country==='KR'?'KRW':'JPY',price,weight,cigarCount,pipeWeight,ryoWeight,ryoMixed,base,exempt,status,total,rows,notes,equivalent,cashCost,landed:cashCost+total,estimated:items.some(i=>i.estimated),exciseWaived,exciseAssessed,reliefOptions,mixedRelief};
    result.reliefScenarios=[];
    result.looseWeight=pipeWeight+ryoWeight;
    result.jpMultipleClassifications=order.country==='JP'&&new Set(items.map(i=>i.type==='cigar'?'cigar':i.type==='ryo'&&i.ryoPaper==='yes'?'rolling-with-paper':'pipe')).size>1;
    return result;
  }
  function validateCatalog(entries) {
    if (!Array.isArray(entries) || entries.length>1000) throw new Error('목록은 최대 1,000개 상품의 배열이어야 합니다.');
    return entries.map((entry,index)=>{
      if (typeof entry !== 'object' || entry===null || typeof entry.name!=='string' || !entry.name.trim() || entry.name.length>120) throw new Error('상품명을 확인해 주세요.');
      itemWeight(entry);number(entry.price,'상품 가격');
      return {id:'custom-'+Date.now()+'-'+index,name:entry.name.trim(),type:entry.type,quantity:Number(entry.quantity),price:Number(entry.price),mode:entry.mode,weight:entry.weight,weightBasis:entry.weightBasis,unit:entry.unit,length:entry.length,lengthUnit:entry.lengthUnit,ring:entry.ring,shape:entry.shape,ryoPaper:entry.type==='ryo'?(entry.ryoPaper||'unknown'):undefined};
    });
  }
  return {OZ_TO_G,MEASUREMENTS,DENSITY,RULES,itemWeight,calculate,validateCatalog,floor,japanDutyRate,japanDeclarationTaxes,japanTobaccoLines};
});
